import { applicationsApi } from "@/api/applicatonsApi";
import { mapApplicationsMachines } from "@/stores/helpers/conditionAnalyzerHelper";
import MachineTestReports from "@/stores/modules/conditionAnalyzer/MachineTestReportsModule";

export default {
  state: {
    apps: [],
    machineApplications: {},
    loadingApps: true,
    selectedMachineId: undefined
  },
  getters: {
    getLoading: state => state.loadingApps,
    getAllApps: state => state.apps,
    getMachineApplications: state => state.machineApplications,
    getMachineApplicationById: state => id => {
      return state.machineApplications && state.machineApplications[id];
    },
    getApplicationsByMachineApplicationId: state => id => {
      return (
        state.machineApplications &&
        state.machineApplications[id] &&
        state.machineApplications[id].applications
      );
    },
    getApplicationsByMachine: (state, getters) => machine => {
      const id = machine && machine.Id;
      const apps = getters.getApplicationsByMachineApplicationId(id);
      return apps;
    },
    selectedMachineId: state => {
      return state.selectedMachineId;
    }
  },
  actions: {
    async fetchApplications({ commit }) {
      let applications = undefined;

      commit("SET_LOADING", true);

      try {
        const allApps = await applicationsApi.getApplications();

        commit("SET_APPS", allApps);

        const machineApplications = await applicationsApi.getMachinesApplications();

        applications = machineApplications.reduce((acc, machineApps) => {
          const { id } = machineApps;

          acc[id] = {
            ...machineApps,
            applications: mapApplicationsMachines({ ...machineApps }, allApps)
          };
          return acc;
        }, {});
      } catch (e) {
        console.error("[Error] Get applications failed.", e);
      }
      commit("SET_MACHINE_APPLICATIONS", applications);

      commit("SET_LOADING", false);
    },
    async fetchMachineApplicationById({ commit }, machineApplicationid) {
      const applications = {};
      try {
        const allApps = await applicationsApi.getApplications();

        const machineApplication = await applicationsApi.getMachineApplicationById(
          machineApplicationid
        );
        applications[machineApplication.id] = {
          ...machineApplication,
          applications: mapApplicationsMachines({ ...machineApplication }, allApps)
        };
      } catch (e) {
        console.error("[Error] Get applications failed.", e);
      }
      commit("SET_MACHINE_APPLICATIONS", applications);
    },
    setSelectedMachineId({ commit }, machineId) {
      commit("SET_SELECTED_MACHINEID", machineId);
    }
  },
  mutations: {
    SET_APPS: (state, apps) => {
      state.apps = apps;
    },
    SET_MACHINE_APPLICATIONS: (state, applications) => {
      if (applications) {
        state.machineApplications = { ...state.machineApplications, ...applications };
      }
    },
    SET_LOADING: (state, loadingApps) => {
      state.loadingApps = loadingApps;
    },
    SET_SELECTED_MACHINEID: (state, machineId) => {
      state.selectedMachineId = machineId;
    },
    RESET: state => {
      state.selectedMachineId = undefined;
      state.machineApplications = {};
      state.loadingApps = false;
      state.apps = [];
    }
  },
  namespaced: true,
  modules: {
    MachineTestReports
  }
};
